import React, { useEffect, useRef, useState } from "react";
import "./Banner.css";
import axios from "axios";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import DownArrow from "./Animation/DownArrow";

function Banner() {


  const data = ["/assets/images/home/banner/gee_banner.png"]

  console.log(data, "data");

  return (
    <section className="home_banner_sec">
      <div className="container">
        <div className="slider_main">
          <Swiper
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {data?.map((val) => (
              <SwiperSlide>
                <div className="sliderdiv">
                  <img
                    className="bannerimg"
                    src={process.env.PUBLIC_URL + val}
                    alt="banner-img"
                  />
                </div>
              </SwiperSlide>
            ))}

         

            <div className="downarrowalign">
              <DownArrow />
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Banner;
